import * as angular from 'angular';

import { DeleteReportDirective } from '@mode/reports/ui';
import { ConfirmDialogService } from '@mode/shared/ui';
import { ToastService } from '@mode/shared/util-toast';
import { DataViewFacade } from '@mode/switch-views/contract';
/* uses of this directive can be migrated from
mode-delete-report report="report" on-report-deleted="onReportDeleted($reportToken)"
to
modeDeleteReport [report]="report" (report-deleted)="onReportDeleted({ $reportToken: $event})"
*/

const deleteReportModalDirective = function (
  confirmDialogService: ConfirmDialogService,
  toastService: ToastService,
  dataviewFacade: DataViewFacade
) {
  return {
    restrict: 'A',
    scope: {
      report: '=',
      onReportDeleted: '&',
    },
    link: function ($scope: angular.IScope, elem) {
      elem.on('click.deleteReportModal', (event) => {
        const deleteReportDirective = new DeleteReportDirective(confirmDialogService, toastService, dataviewFacade);
        deleteReportDirective.report = $scope.report;
        deleteReportDirective.reportDeleted.subscribe((reportToken: String) =>
          $scope.onReportDeleted({ $reportToken: reportToken })
        );
        deleteReportDirective.handleClick(event);
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.deleteReportModal'));
    },
  };
};

deleteReportModalDirective.$inject = ['ConfirmDialogService', 'ToastService', 'DataViewFacade'];

angular.module('mode.components').directive('modeDeleteReport', deleteReportModalDirective);
